import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Heading,
  ProgressCircle,
} from "@americanexpress/dls-react";
import "./ConfirmationStyle.css";
import SignatoryTable from "./SignatoryTable";
import Header from "../Header/Header";
import axios from "axios";
import i18next from "i18next";
import TickIcon from "../../assets/thankyou.svg";
import one from "../../assets/Group 363.svg";
import two from "../../assets/Group 386.svg";
import three from "../../assets/progress 3.svg";
import ErrorIcon from "../../assets/erroricon.svg";
import Timer from "../Timer/Timer";
import { v4 } from 'uuid';
import {
  APPLICATION_JSON, CREATE, MODIFY,
  VERIFY_CAPTCHA, CAPTCHA_FAILED, USER_FIELDS, MODIFY_PIN_RETAINING_COUNTRIES,
  MODIFY_ACCESS_OPTIONAL_COUNTRIES,
} from "../Common/constants";
import { isLanguageEnglish } from "../Common/utils";

const ConfirmationPage = () => {
  const { t, i18n } = useTranslation("common");
  const history = useHistory();
  const location = useLocation();
  const reRef = useRef();

  const [state, setState] = useState({
    count: 0,
    usersmain: location.state?.[0] || [],
    minutes: 0,
    seconds: 0,
    success: false,
    fail: false,
    trid: "",
    i: 0,
    submit: false,
    show: false,
    display: false,
    base64: "",
    token: "",
    isLoading: false,
  });

  useEffect(() => {
    i18next.changeLanguage(localStorage.getItem("lang"));
    window.scrollTo(0, 0);
  }, []);

  const setToken = (userToken) => setState((prev) => ({ ...prev, token: userToken }));

  const onSubmit = async () => {
    setState((prev) => ({ ...prev, submit: true, display: true }));
    if (!state.token) {
      alert(VERIFY_CAPTCHA);
      return;
    }
    try {
      await axios.get("/verifyCaptcha", { data: { token: state.token } });
      prepareSubmit(state.usersmain);
    } catch (err) {
      alert(err?.response?.data?.error || CAPTCHA_FAILED);
    } finally {
      reRef.current?.reset();
      setToken("");
    }
  };

  const reviewData = () => {
    history.push("/thankyou", [
      state.usersmain,
      state.minutes,
      state.seconds,
      i18next.language,
      state.base64,
      state.trid,
      location.state?.[3],
    ]);
  };

  const prepareSubmit = (userDetails) => {
    const newusers = userDetails.map((user) => ({
      ...user,
      accesses: user.access,
    }));
    postData(newusers);
  };

  const createModifyUser = async (finalobj, operation) => {
    const apiUrl = operation === CREATE ? "/createuser" : "/modifyuser";
    setState((prev) => ({ ...prev, isLoading: true }));
    try {
      const res = await axios.post(apiUrl, finalobj, {
        headers: {
          "Content-Type": APPLICATION_JSON,
          "one-data-correlation-id": v4(),
        },
      });
      if (res?.data?.transactionId) {
        setState((prev) => ({
          ...prev,
          isLoading: false,
          success: true,
          base64: res.data.documentContent,
          trid: res.data.transactionId,
        }));
      } else {
        setState((prev) => ({ ...prev, isLoading: false, fail: true }));
      }
    } catch {
      setState((prev) => ({ ...prev, isLoading: false, fail: true }));
    }
  };

  const postData = async (users) => {
    const pinRetainingCountries = MODIFY_PIN_RETAINING_COUNTRIES(t);
    const eurozoneCountries = MODIFY_ACCESS_OPTIONAL_COUNTRIES(t);
    users.forEach((user) => {
      if (!user.eeaCheckbox) user.globalDataTransFiles = [];
      if (
        user.modifyFirstName === "" &&
        user.modifyMiddleName === "" &&
        user.modifyLastName === "" &&
        !user.modifyCheckBox
      ) {
        user.supportingFiles = [];
      }
      if (location.state?.[3] && !pinRetainingCountries.includes(user.country)) {
        delete user.birthMonthDay;
        delete user.verificationPin;
      }
      if (eurozoneCountries.has(user.country)) {
        delete user.birthMonthDay;
      }

      if (
        user.country !== t("access.JAPAN") &&
        user.country !== t("access.NEWZEALAND") &&
        user.country !== t("access.UNITEDKINGDOM")
      ) {
        delete user.residenceAddress;
      }

      if (user.country === "JAPAN" || user.country === "AUSTRALIA") {
        delete user.verificationWord;
      }
      if (!user.organisationNumber) {
        delete user.organisationNumber;
      }
      user.existingProgramAdministrator = user.selfenroll === "1";
      if (location.state?.[3] && user.accesses.length === 0) {
        user.accesses = [{ functions: [] }];
      }
      user.accesses.forEach((acc) => {
        acc.functions.forEach((fun) => {
          if (fun?.membershipRewardsAccountNumber == null || fun?.membershipRewardsAccountNumber === "") {
            delete fun.membershipRewardsAccountNumber;
          } else {
            fun.membershipRewardsAccountNumber = parseInt(fun.membershipRewardsAccountNumber);
          }
          fun.roles.forEach((rol) => {
            if (rol.mmid === "") {
              delete rol.mmid;
            } else {
              rol.membershipRewardsAccountNumber = parseInt(rol.mmid);
              delete rol.mmid;
            }
            delete rol.docNames;
            rol.documents = rol.files;
            delete rol.files;
          });
          if (acc.country !== t("access.AUSTRALIA")) {
            delete fun.maxLimitPerToken;
            delete fun.maxSpendPerDay;
            delete fun.thresholdAmount;
            delete fun.fundingBillingAccount;
            delete fun.dailyNumberOfTokens;
          } else if (fun.fundingBillingAccount === "") {
            delete fun.maxLimitPerToken;
            delete fun.maxSpendPerDay;
            delete fun.thresholdAmount;
            delete fun.notificationRecipient;
            delete fun.fundingBillingAccount;
            delete fun.dailyNumberOfTokens;
          } else {
            fun.dailyNumberOfTokens = parseInt(fun.dailyNumberOfTokens);
            fun.maxLimitPerToken = {
              currency: "AUD",
              amount: fun.maxLimitPerToken,
            };
            fun.maxSpendPerDay = {
              currency: "AUD",
              amount: fun.maxSpendPerDay,
            };
            fun.thresholdAmount = {
              currency: "AUD",
              amount: fun.thresholdAmount,
            };
          }
        });
      });
      const lang = i18next.language;
      const authorizedSignatoriesCount = +user.authorizedSignatoriesCount || 0;
      user.authorizedSignatories = authorizedSignatoriesCount > 0 ?
        (user?.authorizedSignatories?.slice(0, authorizedSignatoriesCount) || []) :
        (user?.authorizedSignatories || []);
      user.authorizedSignatories?.map((auth) => {
        auth.name = lang === "jap"
          ? `${auth.lastName} ${auth.firstName}`
          : `${auth.firstName} ${auth.lastName}`;
        auth.countries = user.selfenroll === "1"
          ? auth.country.map((cntry) => cntry.country)
          : auth.country;
      });
      USER_FIELDS.forEach((key) => delete user[key]);
    });

    const lang = i18next.language;
    const finalobj = {
      language: lang === "jap" ? "ja" : "en",
      users,
    };

    if (location.state?.[3]) {
      console.log("Modify Journey Final Object = ", finalobj);
      createModifyUser(finalobj, MODIFY);
    } else {
      console.log("Add Journey Final Object = ", finalobj);
      createModifyUser(finalobj, CREATE);
    }
  };

  const { display, success, usersmain, fail, isLoading } = state;
  const modifyUser = location.state?.[3];

  return (
    <>
      <Header />
      <div className="confheader">
        <div className="headingc">
          <div className="step">
            <div className="step-counter">
              <img src={one} className="stepimg" alt="step1" />
              <span className="active"> {t("newuser.userdetails")}</span>
            </div>
            <div className="step-counter">
              <img src={two} className="stepimg" alt="step2" />
              <span className="active">{t("access.approval")}</span>
            </div>
            <div className="step-counter">
              <img src={three} className="stepimg" alt="step3" />
              <span className="active">{t("confirm.confirmdetails")}</span>
            </div>
          </div>
          <div className="timer">
            <Timer time={"0"} hist={history} />
          </div>
        </div>
      </div>

      <section id="confirmation-page" className="confirmationPage mainBody">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <Heading level={1} headingStyle={"heading5"} className="margin-1-b">
                {modifyUser ? t("newuser.modifyheading") : t("confirm.pageHeading")}
              </Heading>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div id="confirmation-box" className="confirmationPageContent">
                <Heading level={4} className={"dls-deep-blue"}>
                  {t("confirm.confirmAccess")}
                </Heading>
                {usersmain.length > 0 && (
                  <>
                    {usersmain.map((user, index) => {
                      return (
                        <div className="confirmdiv" key={index}>
                          <div className="col1">
                            <h3>
                              <b>
                                {modifyUser
                                  ? t("confirm.modifyPAHeading")
                                  : t("confirm.newPAHeading")}{" "}
                                {index + 1}
                              </b>
                            </h3>
                            <div className="confirmuserdata">
                              <table>
                                <tbody>
                                  {user.userId && (
                                    <tr>
                                      <td className="labelName">
                                        <b>{t("newuser.userid")}:</b>
                                      </td>
                                      <td className="labelValue">{user.userId}</td>
                                    </tr>
                                  )}
                                  {isLanguageEnglish(i18n.language) ? (
                                    <>
                                      <tr>
                                        <td className="labelName">
                                          <b>{t("newuser.fn")}:</b>
                                        </td>
                                        <td className="labelValue">{user.firstName}</td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          <b>{t("newuser.ln")}:</b>
                                        </td>
                                        <td className="labelValue">{user.lastName}</td>
                                      </tr>
                                    </>
                                  ) : (
                                    <>
                                      <tr>
                                        <td className="labelName">
                                          <b>{t("newuser.ln")}:</b>
                                        </td>
                                        <td className="labelValue">{user.lastName}</td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          <b>{t("newuser.fn")}:</b>
                                        </td>
                                        <td className="labelValue">{user.firstName}</td>
                                      </tr>
                                    </>
                                  )}
                                  {user.phoneNumber && (
                                    <tr>
                                      <td className="labelName">
                                        <b>
                                          {user.country === t("access.UNITEDKINGDOM")
                                            ? t("common.TelephoneNumber")
                                            : t("confirm.phno")}
                                          :
                                        </b>
                                      </td>
                                      <td className="labelValue">{user.phoneNumber}</td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td className="labelName">
                                      <b>
                                        {user.country === t("access.UNITEDKINGDOM")
                                          ? t("common.EmailAddress")
                                          : t("confirm.businessemail")}
                                        :
                                      </b>
                                    </td>
                                    <td className="labelValue">{user.emailId}</td>
                                  </tr>
                                  {!modifyUser && user.country && (
                                    <tr>
                                      <td className="labelName">
                                        <b>{t("confirm.country")}:</b>
                                      </td>
                                      <td className="labelValue">{user.country}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {user.access.map((acc, accIdx) => (
                              <React.Fragment key={accIdx}>
                                <h3>
                                  <b>
                                    {t("newuser.access")}
                                    {accIdx + 1}
                                  </b>
                                </h3>
                                <div className="confirmuserdata">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td className="labelName">
                                          <b>{t("confirm.country")}: </b>
                                        </td>
                                        <td className="labelValue">{acc.country}</td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          <b>{t("confirm.controlacno")}:</b>
                                        </td>
                                        <td className="labelValue">{acc.controlAccountNumber}</td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          <b>{t("confirm.function")}:</b>
                                        </td>
                                        <td className="labelValue">
                                          {acc.functions.map((funct, fIdx) => (
                                            <p key={fIdx}>{funct.functionName}</p>
                                          ))}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="labelName rolesLabel">
                                          {acc.functions.some((funct) => funct.roles.length > 0) && <b>Roles:</b>}
                                        </td>
                                        <td className="labelValue">
                                          {acc.functions.map((funct, fIdx) => (
                                            funct.roles.length > 0 && (
                                              <React.Fragment key={fIdx}>
                                                {funct.roles.map((rol, rIdx) => (
                                                  rol.roleName && <p key={rIdx}>{rol.roleName}</p>
                                                ))}
                                              </React.Fragment>
                                            )
                                          ))}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </React.Fragment>
                            ))}
                          </div>
                          <div className="col2">
                            <div className="approvalDiv">
                              <h3>
                                {isLanguageEnglish(i18n.language) && (
                                  <b>
                                    {t("confirm.useraccess")} {index + 1}
                                  </b>
                                )}
                              </h3>
                              <SignatoryTable user={user} t={t} i18n={i18n} userIdx={index} />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="reviewText">
                      <h3 className="margin-2-b">
                        <b>{t("confirm.pleaserview")}</b>
                      </h3>
                      <p className="margin-1-b">{t("confirm.clicksubmit")}</p>
                      <p>{t("confirm.future")}</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="captcha" className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="recaptchaDiv">
              {/* ReCAPTCHA component with site key based on environment, during development allows all*/}
              {/* https://developers.google.com/recaptcha/docs/faq*/}
              <ReCAPTCHA
                sitekey={process.env.NODE_ENV === "development"
                  ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                  : "6LeMcCUaAAAAAERRHEXpgOdMbvCy6OhCiN3jRh4Q"}
                ref={reRef}
                onChange={setToken}
                onExpired={() => setToken("")}
              />
            </div>
          </div>
        </div>
      </section>

      <section id="submut-form" className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="float-right">
              <Button
                styleType="primary"
                onClick={() => {
                  history.push("/access-approver", [
                    state.usersmain,
                    state.minutes,
                    state.seconds,
                    "prev",
                    location.state?.[3],
                    location.state?.[4],
                    location.state?.[5],
                    location.state?.[6],
                  ]);
                }}
                style={{ margin: "20px" }}
              >
                {t("newuser.returnapprover")}
              </Button>
              <Button styleType="primary" onClick={onSubmit} disabled={isLoading}>
                {t("confirm.submit")}
              </Button>
            </div>
          </div>
        </div>
      </section>

      {isLoading && (
        <div className="submission-loader-overlay">
          <ProgressCircle />
        </div>
      )}

      {fail && (
        <Modal>
          <ModalBody>
            <div className="padResponsiveExtraLr errorBody">
              <img src={ErrorIcon} alt="erroricon" />
              <h4>{t("confirm.errorFormSubmission")}</h4>
              <p className="pad-2-b">{t("confirm.errorTryAgain")}</p>
            </div>
          </ModalBody>
          <ModalFooter className="mfooter">
            <div>
              <Link
                className="pad-2-r"
                to={modifyUser ? "/modify-user" : "/new-user"}
              >
                <Button styleType="primary">{t("confirm.startAgain")}</Button>
              </Link>
              <Link to="/">
                <Button>{t("confirm.goToHome")}</Button>
              </Link>
            </div>
          </ModalFooter>
        </Modal>
      )}

      {display && success && (
        <Modal className="confirmationModal">
          <ModalBody>
            <div className="padResponsiveExtraLr">
              <h4>{t("access.success")}</h4>
              <br />
              <div>
                <img src={TickIcon} alt="successicon" />
              </div>
              <br />
              <h4>{t("access.thankyou")}</h4>
              <h4>
                {t("thankYou.userTransactionId")} : {state.trid}
              </h4>
              <br />
            </div>
          </ModalBody>
          <ModalFooter className="footer">
            <Button styleType="primary" onClick={reviewData}>
              {t("confirm.thankyou")}
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default ConfirmationPage;
